<template>
    <div class="client-card">
        <e-img lazy class="icon" :src="src" :class="{ 'bg': bg }" :alt="altTag"></e-img>
        <div class="name">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: `client-card`,
        props: {
            src: { type: String },
            bg: { type: Boolean }
        },
        computed: {
            altTag() {
                try {
                    const text = this.$slots.default[0].text.trim();

                    let altPrefix = ``;
                    if (this.$parent && this.$parent.altPrefix) {
                        altPrefix = this.$parent.altPrefix + ` `;
                    } else if (this.$parent && this.$parent.$parent && this.$parent.$parent.altPrefix) {
                        altPrefix = this.$parent.$parent.altPrefix + ` `;
                    }
                    return altPrefix + text;
                } catch (e) {
                    return null;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .client-card {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        width: 192px;
        height: 120px;
        margin: 10px;
        letter-spacing: 0.4px;
        font-size: 9pt;
        text-decoration: none !important;

        picture,
        img {
            position: relative;
            width: 192px;
            height: 96px;
            object-fit: cover;
            border-radius: 12px;

            ::v-deep img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 12px;
            }

            &.bg {
                padding: 5px;
                background-color: #ffffff;
            }
            //box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
        }

        .name {
            padding: 5px;
            width: 100%;
            font-weight: 500;
            text-align: center;
            text-overflow: ellipsis;
        }
    }

    @media(max-width: 576px) {
        .client-card {
            width: 110px;
            height: 92px;
            margin: 5px;

            picture,
            img {
                position: relative;
                width: 110px;
                height: 54px;
            }

            .name {
                overflow: hidden;
            }
        }
    }
</style>
